import { predictions } from "config/algolia";

const DEFAULT_LENGTH = 10;
export const getPredictions = async ({
  filters = "",
  searchText = "",
  length = DEFAULT_LENGTH,
  offset = 0,
}) => {
  const result = await predictions.search(searchText, {
    filters,
    length,
    page: offset,
    hitsPerPage: length,
    highlightPreTag: "<mark>",
    highlightPostTag: "</mark>",
  });
  return {
    hits: result.hits,
    hitsLength: result.nbHits,
  };
};
